import { Link as ScrollLink } from 'react-scroll';

export default function ScrollNav(props) {
    const links = props.links;

return (
    <div className="hidden sm:flex fixed justify-center items-center w-full h-0 px-4 bg-transparent text-blue-300 black-ops-font">
        <ul className="flex space-x-4">
            {links.map((link, index) => (
                <li key={index} className="cursor-pointer">
                    <ScrollLink to={link} smooth duration={500}>{link}</ScrollLink>
                </li>
            ))}
        </ul>
    </div>
)
}
